import { Component } from '../core/smpl-components.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// -----------------------------------------------------------------------------
// Footer — the two reading characters pop up from the bottom edge, one after
// the other with a bounce, when the footer scrolls into view. Each is its own
// image (`.footer__character figure`), so they rise separately. Scrolling back
// up past them hides them again, so the reveal plays every time you arrive.
// The stylesheet clips them at the bottom edge while they wait.
// Selector: `.js-footer`.
// -----------------------------------------------------------------------------

// When they come up: once this much of the characters' box has entered from
// the bottom of the viewport.
const START = 'top+=40% bottom'

// Seconds between the first and the second character.
const STAGGER = 0.05

const RISE = { duration: 0.5, ease: 'elastic.out(0.8, 0.9)' }

export default class extends Component {
	mount() {
		const box = this.element.querySelector('.footer__character')
		if (!box || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

		this.tween = gsap.from(box.querySelectorAll('figure'), {
			yPercent: 100,
			stagger: STAGGER,
			...RISE,
			scrollTrigger: { trigger: box, start: START },
		})

		// Hide them again only once the whole box is back below the viewport, so
		// the reset is never seen and the next arrival replays the reveal.
		this.reset = ScrollTrigger.create({
			trigger: box,
			start: 'top bottom',
			onLeaveBack: () => this.tween.pause(0),
		})
	}

	unmount() {
		this.reset?.kill()
		this.tween?.scrollTrigger.kill()
		this.tween?.revert()
		this.tween = this.reset = null
	}
}
